import React, { useEffect, useState } from "react";
import { Button, HStack, Popover, Text, Portal, Separator, createListCollection, Dialog, VStack, Select, CloseButton, Spinner, Field, Box, Textarea, Input } from "@chakra-ui/react";

import { LuText, LuTextQuote, LuView } from "react-icons/lu";
import { Tooltip } from "../../../ui/tooltip";
import { deleteDrawingForComment, handleSelectingForComment } from "../../../../utilies/ReviewPanelUtility";
import Type from "../../../../utilies/Types";

import { floatingStyles, removeFileExtension, ReviewTitleOptions, showToast, swapLatLon } from "../../../../utilies/Utility";
import { serviceComment } from "../../../../api/services/comment";
import CommentReviewDialog from "../../right/CommentReviewDialog";
import { useAppStore } from "../../../../context/store";
import { useMapObjects } from "../../../../context/MapObjectsContext";
const AddCommentDialog = ({ state }) => {
  const userData = useAppStore((s) => s.userData);
  const commentSendingData = useAppStore((s) => s.commentSendingData);
  const city = useAppStore((s) => s.city);
  const selectedProject = useAppStore((s) => s.selectedProject);
  const activeLayer = useAppStore((s) => s.activeLayer);
  const { mapObjects } = useMapObjects();
  const reviewTitle = useAppStore((s) => s.reviewTitle);
  const tasks = useAppStore((s) => s.tasks);
  const selectedTask = useAppStore((s) => s.selectedTask);
  const viewerRef = useAppStore.getState().viewerRef;

  const [titleOptions, setTitleOptions] = useState(
    createListCollection({
      items: [],
    })
  );
  useEffect(() => {
    if (reviewTitle.length > 0) {
      try {
        const source = Array.isArray(reviewTitle) ? reviewTitle : [];

        const groupedByCategory = source.reduce((acc, item) => {
          const cat = item?.category ?? "uncategorized"; // fallback in case of missing category
          if (!acc[cat]) acc[cat] = [];
          acc[cat].push(item);
          return acc;
        }, {});

        let items = Object.entries(groupedByCategory).map(([category, arr]) => {
          const options = arr
            .slice()
            .sort((a, b) => a.type.localeCompare(b.type))
            .map((it) => ({
              label: it.type, // e.g., "Feature Not Sliced"
              value: it.type_short, // e.g., "feature_not_sliced"
            }));

          return { category, options };
        });

        items = items.sort((a, b) => a.category.localeCompare(b.category));

        setTitleOptions(
          createListCollection({
            items,
          })
        );
      } catch (e) {}
    }
  }, [reviewTitle]);

  const [context, setContext] = useState("");
  const [title, setTitle] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedLayer, setSelectedLayer] = useState("");
  const [selectedFormTask, setSelectedFormTask] = useState("");
  const [isProgress, setIsProgress] = useState(false);

  const [cityOptions, setCityOptions] = useState(
    createListCollection({
      items: [],
    })
  );
  const [taskOptions, setTaskOptions] = useState(
    createListCollection({
      items: [],
    })
  );
  const [layersOptions, setLayersOptions] = useState(
    createListCollection({
      items: [],
    })
  );
  useEffect(() => {
    if (state[0]) {
      for (const key in mapObjects) {
        if (mapObjects[key].id == activeLayer) {
          if (mapObjects[key].layer_id) {
            setSelectedLayer(mapObjects[key].layer_id);
          }
          break;
        }
      }

      setContext("");
      setTitle("");
      setIsProgress(false);
      setSelectedCity(selectedProject?.city);
      setSelectedFormTask(selectedTask?.id);

      let temp = [];
      for (const key in city) {
        temp.push({ label: city[key].name, value: city[key].name.toLowerCase() });
      }
      setCityOptions(
        createListCollection({
          items: temp,
          itemToString: (item) => item.label,
          itemToValue: (item) => item.value,
        })
      );

      let temp2 = [{ label: "No Layer", value: "" }];
      for (const key in mapObjects) {
        if (mapObjects[key].layer_id) {
          temp2.push({ label: removeFileExtension(mapObjects[key].file_name), value: mapObjects[key].layer_id });
        }
      }
      setLayersOptions(
        createListCollection({
          items: temp2,
          itemToString: (item) => item.label,
          itemToValue: (item) => item.value,
        })
      );

      let temp3 = [{ label: "No Layer", value: "" }];
      for (const key in tasks) {
        if (tasks[key].status == "in_progress" || tasks[key].status == "review") {
          temp3.push({ label: tasks[key].title, value: tasks[key].id });
        }
      }
      setTaskOptions(
        createListCollection({
          items: temp3,
          itemToString: (item) => item.label,
          itemToValue: (item) => item.value,
        })
      );
    }
  }, [state[0]]);

  // Send comment to server
  const add = () => {
    if (!title.trim()) {
      showToast("Title cannot be empty", Type.NOTIFICATION.ERROR);
      return;
    }
    if (!context.trim()) {
      showToast("Description cannot be empty", Type.NOTIFICATION.ERROR);
      return;
    }
    if (!selectedProject) {
      showToast("Project not selected", Type.NOTIFICATION.ERROR);
      return;
    }

    let temp = { ...commentSendingData };
    temp.context = context;
    temp.title = title;
    temp.city = selectedCity;
    temp.timestamp = Math.floor(Date.now() / 1000);
    temp.project_id = selectedProject.id;

    if (selectedLayer) {
      temp.layer_id = selectedLayer;
    }

    if (selectedFormTask) {
      temp.task_id = selectedFormTask;
    }

    setIsProgress(true);
    serviceComment({
      username: userData.user.username,
      task_admin: userData.user.username,
      data: JSON.stringify(temp),
    })
      .then((res) => {
        setIsProgress(false);
        if (res.status) {
          showToast("Comment added", Type.NOTIFICATION.SUCCESS);
          deleteDrawingForComment(viewerRef.current);
          state[1](false);
        }
      })
      .catch((err) => {
        setIsProgress(false);
        showToast(err.message, Type.NOTIFICATION.ERROR);
        console.error("Error", err);
      });
  };

  return (
    <Dialog.Root
      scrollBehavior="inside"
      placement={"top"}
      motionPreset="slide-in-right"
      closeOnInteractOutside={false}
      modal={false}
      open={state[0]}
      onOpenChange={(e) => {
        state[1](e.open);
      }}
    >
      <Portal>
        <Dialog.Positioner pointerEvents="none" height={"calc(100% - 90px)"}>
          <Dialog.Content mr={"80px"} mb={0} mt={"70px"} height={"100%"} width={"400px"} maxWidth={"400px"} borderRadius={"2xl"}>
            <Dialog.Header>
              <VStack>
                <Dialog.Title width={"full"}> New Comment</Dialog.Title>
                <Text width={"full"}>Active Project: {selectedProject?.project_name}</Text>
              </VStack>
            </Dialog.Header>
            <Dialog.Body>
              <Select.Root
                collection={titleOptions}
                size="sm"
                width="full"
                onValueChange={(v) => {
                  setTitle(v.value[0]);
                }}
              >
                <Select.HiddenSelect />
                <Select.Label>
                  <HStack>
                    <LuText /> Title
                  </HStack>
                </Select.Label>
                <Select.Control>
                  <Select.Trigger>
                    <Select.ValueText placeholder={title ? title : "Select Title"} />
                  </Select.Trigger>
                  <Select.IndicatorGroup>
                    <Select.ClearTrigger />
                    <Select.Indicator />
                  </Select.IndicatorGroup>
                </Select.Control>

                <Select.Positioner>
                  <Select.Content>
                    <ReviewTitleOptions collection={titleOptions} />
                  </Select.Content>
                </Select.Positioner>
              </Select.Root>

              <Select.Root
                collection={cityOptions}
                size="sm"
                width="full"
                positioning={{ sameWidth: true }}
                value={[selectedCity]}
                onValueChange={(value) => {
                  setSelectedCity(value.value[0]);
                }}
              >
                <Select.HiddenSelect />
                <Select.Label mt={2}>Select City</Select.Label>
                <Select.Control>
                  <Select.Trigger>
                    <Select.ValueText placeholder={selectedCity ? selectedCity : "Select City"} />
                  </Select.Trigger>
                  <Select.IndicatorGroup>
                    <Select.Indicator />
                  </Select.IndicatorGroup>
                </Select.Control>
                <Select.Positioner>
                  <Select.Content>
                    {cityOptions.items.map((item) => (
                      <Select.Item key={item.value} item={item} justifyContent="flex-start">
                        {item.label}
                        <Select.ItemIndicator />
                      </Select.Item>
                    ))}
                  </Select.Content>
                </Select.Positioner>
              </Select.Root>

              <Select.Root
                collection={layersOptions}
                size="sm"
                width="full"
                positioning={{ sameWidth: true }}
                value={[selectedLayer]}
                onValueChange={(value) => {
                  setSelectedLayer(value.value[0]);
                }}
              >
                <Select.HiddenSelect />
                <Select.Label mt={2}>Select Layer</Select.Label>
                <Select.Control>
                  <Select.Trigger>
                    <Select.ValueText placeholder={"Select Layer"} />
                  </Select.Trigger>
                  <Select.IndicatorGroup>
                    <Select.Indicator />
                  </Select.IndicatorGroup>
                </Select.Control>
                <Select.Positioner>
                  <Select.Content>
                    {layersOptions.items.map((item) => (
                      <Select.Item key={item.value} item={item} justifyContent="flex-start">
                        {item.label}
                        <Select.ItemIndicator />
                      </Select.Item>
                    ))}
                  </Select.Content>
                </Select.Positioner>
              </Select.Root>

              <Select.Root
                collection={taskOptions}
                size="sm"
                width="full"
                positioning={{ sameWidth: true }}
                value={[selectedFormTask]}
                onValueChange={(value) => {
                  setSelectedFormTask(value.value[0]);
                }}
              >
                <Select.HiddenSelect />
                <Select.Label mt={2}>Select Task</Select.Label>
                <Select.Control>
                  <Select.Trigger>
                    <Select.ValueText placeholder={"Select Task"} />
                  </Select.Trigger>
                  <Select.IndicatorGroup>
                    <Select.Indicator />
                  </Select.IndicatorGroup>
                </Select.Control>
                <Select.Positioner>
                  <Select.Content>
                    {taskOptions.items.map((item) => (
                      <Select.Item key={item.value} item={item} justifyContent="flex-start">
                        {item.label}
                        <Select.ItemIndicator />
                      </Select.Item>
                    ))}
                  </Select.Content>
                </Select.Positioner>
              </Select.Root>

              <Field.Root my={4}>
                <Box pos="relative" w="full">
                  <Textarea className="peer" placeholder="" type="text" rows={7} value={context} onChange={(v) => setContext(v.target.value)} />

                  <Field.Label css={floatingStyles}>
                    <LuText /> Description
                  </Field.Label>
                </Box>
              </Field.Root>

              {commentSendingData.feature_id && (
                <Field.Root mt={3}>
                  <Field.Label>Feature ID</Field.Label>
                  <Input value={commentSendingData.feature_id} disabled />
                </Field.Root>
              )}

              {commentSendingData.layer_name && (
                <Field.Root mt={3}>
                  <Field.Label>Layer Name</Field.Label>
                  <Input value={removeFileExtension(commentSendingData.layer_name)} disabled />
                </Field.Root>
              )}

              {commentSendingData.bbox && (
                <Field.Root mt={5}>
                  <Box pos="relative" w="full">
                    <Textarea className="peer" placeholder="" type="text" rows={5} disabled value={JSON.stringify(commentSendingData.bbox)} />
                    <Field.Label css={floatingStyles}>
                      <LuText /> BBOX
                    </Field.Label>
                  </Box>
                </Field.Root>
              )}
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button
                  variant="outline"
                  onClick={() => {
                    deleteDrawingForComment(viewerRef.current);
                  }}
                >
                  Cancel
                </Button>
              </Dialog.ActionTrigger>
              <Button variant="solid" colorPalette={"green"} onClick={add}>
                {isProgress ? <Spinner size={"sm"} /> : "Add"}
              </Button>
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

function RightMenuReviewerPanel() {
  // state
  const isOpenReviewerPanel = useAppStore((s) => s.isOpenReviewerPanel);
  const isEnableSelectingComment = useAppStore((s) => s.isEnableSelectingComment);
  const showCommentDialog = useAppStore((s) => s.showCommentDialog);
  const selectedProject = useAppStore((s) => s.selectedProject);

  const setIsOpenReviewerPanel = useAppStore.getState().setIsOpenReviewerPanel;
  const viewerRef = useAppStore.getState().viewerRef;
  const originalCameraControls = useAppStore.getState().originalCameraControls;
  const setIsEnableSelectingComment = useAppStore.getState().setIsEnableSelectingComment;
  const setShowCommentDialog = useAppStore.getState().setShowCommentDialog;
  const setCommentSendingData = useAppStore.getState().setCommentSendingData;
  const setIsShowCommentReviewDialog = useAppStore.getState().setIsShowCommentReviewDialog;

  useEffect(() => {
    if (!showCommentDialog) {
      deleteDrawingForComment(viewerRef.current);
    }
  }, [showCommentDialog]);

  const addComment = () => {
    showToast("Please draw a region or click on a feature", Type.NOTIFICATION.INFO);
    setIsEnableSelectingComment(true);
    const handler = handleSelectingForComment(viewerRef.current, originalCameraControls, (data) => {
      handler.destroy();

      switch (data.type) {
        case "entity":
          setCommentSendingData({
            feature_id: data.id,
            context: "",
            bbox: swapLatLon(data.bbox),
          });
          setShowCommentDialog(true);
          setIsOpenReviewerPanel(false);
          break;
        case "rectangle":
          const { west, south, east, north } = data.bounds;
          const polygonCoords = [
            [south, west],
            [south, east],
            [north, east],
            [north, west],
            [south, west],
          ];

          setCommentSendingData({
            bbox: polygonCoords,
            context: "",
            title: "",
          });
          setShowCommentDialog(true);
          setIsOpenReviewerPanel(false);
          break;
      }

      setTimeout(() => {
        setIsEnableSelectingComment(false);
      }, 500);
    });
  };

  const reviewCpmments = () => {
    setIsOpenReviewerPanel(false);
    setIsShowCommentReviewDialog(true);
  };

  return (
    <>
      <Popover.Root positioning={{ placement: "right-start" }} open={isOpenReviewerPanel} onOpenChange={(e) => setIsOpenReviewerPanel(e.open)} closeOnInteractOutside={false}>
        <Popover.Trigger asChild>
          <Button userSelect={"none"} p={2} width={"45px"} height={"45px"} bg={isOpenReviewerPanel ? "green" : "white"} color={isOpenReviewerPanel ? "white" : "MenuText"}>
            <Tooltip content="Reviewer Panel">
              <LuView color={isOpenReviewerPanel ? "white" : "MenuText"} />
            </Tooltip>
          </Button>
        </Popover.Trigger>
        <Portal>
          <Popover.Positioner>
            <Popover.Content width={"200px"}>
              <Popover.Arrow />
              <Popover.Header mb={3}>
                <Popover.Title fontSize={"xl"} width={"full"}>
                  Reviewer Panel
                </Popover.Title>
              </Popover.Header>

              <Popover.Body p={2}>
                <Separator mb={2} />
                {selectedProject && (
                  <Button width={"full"} onClick={addComment} disabled={isEnableSelectingComment} mb={2}>
                    <HStack spacing={2}>
                      <LuTextQuote size={"20px"} />
                      <Text>Add Comment</Text>
                    </HStack>
                  </Button>
                )}

                <Button width={"full"} onClick={reviewCpmments} disabled={isEnableSelectingComment}>
                  <HStack spacing={2}>
                    <LuTextQuote size={"20px"} />
                    <Text>Review Comments</Text>
                  </HStack>
                </Button>
              </Popover.Body>
            </Popover.Content>
          </Popover.Positioner>
          <AddCommentDialog state={[showCommentDialog, setShowCommentDialog]} />
        </Portal>
      </Popover.Root>
      <CommentReviewDialog />
    </>
  );
}

export default RightMenuReviewerPanel;
